import { generateClient, get, post } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

const client = generateClient();

const adminGet = async (path, params) => {
  let apiName = "AdminQueries";
  const filteredParams = Object.fromEntries(
    Object.entries(params || {}).filter(([_, value]) => value !== undefined)
  );
  let options = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await fetchAuthSession()).tokens.accessToken}`
    },
    queryParams: filteredParams

  }
  const response = get({
    apiName,
    path,
    options
  });
  return response
};

const adminPost = async (path, params) => {
  let apiName = "AdminQueries";
  try {
    const postOperation = post({
      path,
      apiName,
      options: {
        body: params,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${(await fetchAuthSession()).tokens.accessToken}`
        }
      }
    });
    const { body } = await postOperation.response
    const response = await body.json()
    return response
  } catch (error) {
    console.error(error);
  }
};

export const makeFilePublic = async (bucket, key) => {
  let path = "/makeFilePublic";
  const params = {
    bucket,
    key,
  };
  return adminPost(path, params);
};

export const makeFilePrivate = async (bucket, key) => {
  let path = "/makeFilePrivate";
  const params = {
    bucket,
    key,
  };
  return adminPost(path, params);
};

export const addUser = async (username, attributes) => {
  let path = "/addUser";
  const params = {
    username,
    attributes,
  };
  return adminPost(path, params);
};

export const updateUserAttributes = async (username, attributes) => {
  let path = "/updateUserAttributes";
  const params = {
    username,
    attributes,
  };
  return adminPost(path, params);
};

export const deleteUser = async username => {
  let path = "/deleteUser";
  const params = {
    username,
  };
  return adminPost(path, params);
};

export const addUserToGroup = async (username, groupname) => {
  let path = "/addUserToGroup";
  const params = {
    username,
    groupname,
  };
  return adminPost(path, params);
};
export const removeUserFromGroup = async (username, groupname) => {
  let path = "/removeUserFromGroup";
  const params = {
    username,
    groupname,
  };
  return adminPost(path, params);
};

export const resetUserPassword = async username => {
  let path = "/resetUserPassword";
  const params = {
    username,
  };
  return adminPost(path, params);
};

export const listUsersInGroup = async (
  groupname,
  limit = undefined,
  nextToken = undefined
) => {
  let path = "/listUsersInGroup";
  const params = {
    groupname,
    limit,
    token: nextToken,
  };
  return adminGet(path, params);
};
export const recursiveListUsersInGroup = async groupname => {
  let retval = { Users: [] };
  let nextToken = undefined

  do {
    const params = await listUsersInGroup(groupname, undefined, nextToken)
    const data = await (await params.response).body.json()
    retval.Users = retval.Users.concat(data.Users || [])
    nextToken = data.NextToken || undefined
  } while (nextToken)
  return retval
};

export const listUsers = async (limit = undefined, nextToken = undefined) => {
  let path = "/listUsers";
  const params = {
    limit: limit,
    token: nextToken,
  };
  return adminGet(path, params);
};

export const getUser = async (sid) => {
  const path = "/GetUser";
  const params = {
    username: sid
  }
  let res = await adminGet(path, params);
  let user = await (await res.response).body.json()
  user.UserAttributes = user.UserAttributes.reduce(
    // eslint-disable-next-line no-sequences
    (obj, item) => ((obj[item.Name] = item.Value), obj),
    {}
  )
  return user;
}
export const recursiveListUsers = async groupname => {
  let retval = { Users: [] };
  const _listUsers = nextToken =>
    listUsers(undefined, nextToken).then(async (params) => {
      const data = await (await params.response).body.json()
      retval.Users = retval.Users.concat(data.Users);
      if (data.NextToken) {
        return _listUsers(data.NextToken);
      } else {
        return retval;
      }
    });
  return _listUsers(undefined);
};

export const listUserGroups = async () => {
  const { Users } = await recursiveListUsers();
  const usernames = (await recursiveListUsersInGroup("User")).Users.map(
    user => user.Username
  );
  const adminnames = (await recursiveListUsersInGroup("Admin")).Users.map(
    admin => admin.Username
  );
  const publicnames = (await recursiveListUsersInGroup("Public")).Users.map(
    publ => publ.Username
  );
  Users.forEach(user => {
    user.Attributes = user.Attributes.reduce(
      // eslint-disable-next-line no-sequences
      (obj, item) => ((obj[item.Name] = item.Value), obj),
      {}
    );
    user.groups = {
      User: usernames.includes(user.Username),
      Admin: adminnames.includes(user.Username),
      Public: publicnames.includes(user.Username),
    };
  });
  return Users;
};
